import { format, parseISO } from 'date-fns'
import React from 'react'
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import BlankSlate from '../../../../../components/BlankSlate'
import dashboardWhite from '../../../../../icones/iconesVersaoClara/dashboard.svg'
import dashboardDark from '../../../../../icones/iconesVersaoEscura/dashboard.svg'

import * as S from './styles'

const CustomTooltip = ({ payload, active }) => {
  if (active && payload && payload.length) {
    const formattedData = format(
      parseISO(payload[0].payload.data),
      'dd/MM/yyyy'
    )

    const hora = payload[0].payload.hora
    const concatData = `${formattedData} - ${hora}`

    return (
      <S.TooltipWrapper>
        <S.TooltipContent>
          <S.TituloTooltip> {concatData}</S.TituloTooltip>
          <S.LinhasWrapper>
            <S.LinhasContent>
              <S.Elipse />
              Linhas
            </S.LinhasContent>
            <span>{payload[0].payload.historico}</span>
          </S.LinhasWrapper>
        </S.TooltipContent>
      </S.TooltipWrapper>
    )
  }

  return null
}

export default function Grafico({ data = [], visibleDate, selectedDate = {} }) {
  const gridColor = '#868E96'
  const lineColor = '#33CC99'
  const eixoY = Math.max(...data.map((item) => item.historico)) + 1

  const localTheme = localStorage.getItem('tema')
  const theme = localTheme || 'claro'
  const isDarkTheme = theme === 'escuro'

  const hasBothDates = selectedDate.start !== null && selectedDate.end !== null

  const corTema = () => {
    if (isDarkTheme) return dashboardDark
    else return dashboardWhite
  }

  if ((!data || !data.length) && visibleDate) {
    return (
      <S.BlankSlateContainer>
        <BlankSlate
          mb={90}
          size="md"
          icon={corTema()}
          title={
            hasBothDates ? 'Sem conexões registradas.' : 'Selecione um período.'
          }
          subTitle={
            hasBothDates
              ? 'Nenhum registro de conexão foi encontrado neste intervalo, ajuste o filtro de datas para ver registros anteriores.'
              : 'Selecione uma data inicial e uma final para fazer uma filtragem.'
          }
        />
      </S.BlankSlateContainer>
    )
  }

  if (!data || !data.length) {
    return (
      <S.BlankSlateContainer>
        <BlankSlate
          mb={90}
          size="md"
          icon={corTema()}
          title="Sem conexões registradas."
          subTitle="Nenhum registro de conexão foi encontrado neste intervalo, ajuste o filtro de datas para ver registros anteriores."
        />
      </S.BlankSlateContainer>
    )
  }

  return (
    <S.Container>
      <S.ConteudoGrafico width={data.length > 15 ? '118%' : '100%'}>
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="linha" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={lineColor} stopOpacity={0.2} />
                <stop offset="95%" stopColor={lineColor} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke={gridColor} strokeDasharray="0" />
            <XAxis
              tick={{ fontSize: 12, fill: gridColor }}
              stroke={gridColor}
              dataKey="hora"
              tickMargin={12}
            />
            <YAxis
              tick={{ fontSize: 12 }}
              stroke={gridColor}
              dataKey="numero_linhas"
              domain={[0, eixoY]}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="linear"
              dataKey="historico"
              stroke={lineColor}
              fillOpacity={1}
              fill="url(#linha)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </S.ConteudoGrafico>
    </S.Container>
  )
}
